import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTabs } from "../../../components";
import { useAuth } from "../../../context/AuthContext";
import { AgentData, MemberData } from "./components";
import styles from "./styles.module.scss";

const SubordinateManagement = () => {
  const { rebateMode } = useAuth();
  const [activeTab, setActiveTab] = useState("agent_data");
  const [currentUser, setCurrentUser] = useState("");
  const [currentSearchTime, setCurrentSearchTime] = useState("");
  const { t } = useTranslation();

  const tabItems = [
    {
      key: "agent_data",
      title: t("subordinateManagement.tabTitle.agentData"),
      component: (
        <AgentData
          outerTab={activeTab}
          setOuterTab={setActiveTab}
          currentUser={currentUser}
          setCurrentUser={setCurrentUser}
          setCurrentSearchTime={setCurrentSearchTime}
          rebateMode={rebateMode}
        />
      ),
      destroyOnClose: false,
    },
    {
      key: "member_data",
      title: t("subordinateManagement.tabTitle.memberData"),
      component: (
        <MemberData
          outerTab={activeTab}
          currentUser={currentUser}
          currentSearchTime={currentSearchTime}
          rebateMode={rebateMode}
        />
      ),
      destroyOnClose: false,
    },
  ];

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div className={styles.subordianteContainer}>
      <CustomTabs activeKey={activeTab} onTabChange={onTabChange} tabItems={tabItems} />
    </div>
  );
};

export default SubordinateManagement;
